import { createFileRoute } from '@tanstack/react-router'
import { PaymentsSection, paymentsLoader } from '@ufc/domains/finance'

export const Route = createFileRoute('/finance/payments')({
  loader: paymentsLoader,
  component: PaymentsPage,
})

function PaymentsPage() {
  return <PaymentsSection />
}
